/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
 */
export interface SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  credentialValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  assistantId: string;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate interface.
 */
export function instanceOfSingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate(
  value: object,
): value is SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateFromJSON(
  json: any,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate {
  return SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
    name: json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreateToJSON(
  value?: SingleTurnChatInferencerCreatePolymorphicSingleTurnChatInferencerPoeCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    credential_id: value['credentialId'],
  };
}
